import { useTranslation } from "react-i18next";
import { GoogleDocsTerms } from "../../components/common/GoogleDocsTerms";

export const Faq = () => {
  const { t } = useTranslation();
  return <GoogleDocsTerms type="faq" title={t("faq")} />;
};
